export default {

    setUser(state, payload) {
        console.log('payload in set user', payload.token)
        state.token = payload.token;
        state.userId = payload.userId;
        state.tokenExpiration = payload.tokenExpiration;
        console.log(state.token)
    },


}